<kb-icon class="type-icon" [icon]="(fileType && fileTypeIcons[fileType]) ? fileTypeIcons[fileType] : iconDownload" icon-uppercase icon-center />
<div class="text">
  <div class="title">
    <ng-content />
    <kb-icon [icon]="iconArrowsRight" />
  </div>
  @if (bytes || fileType) {
    <div class="meta">
      [@if (fileType) {{{ fileType | uppercase }}@if (bytes !== undefined) {, }}@if (bytes !== undefined) {{{ bytes | bytes }}}]
    </div>
  }
</div>
